import axios from "axios";

export interface Article {
    id: number;
    title: string;
    slug: string;
    imgUrl: string;
    category: string;
    updatedDate: Date;
    relatedArticles: number[];
    createdDate: Date;
    isPublic?: boolean;
    isPinned: boolean;
    content: string;
    tags: string[];
    relatedArticlesData?: RelatedArticleDataI[];
    featured: FeaturedI[];
}

export interface FeaturedI {
    title: string;
    type: string;
    items: string[];
}

export type RelatedArticleDataI = Pick<Article, 'id' | 'title' | 'slug' | 'imgUrl' | 'category' | 'updatedDate' | 'isPinned'>;

const API_BASE_URL = "https://portfoliom-backend.vercel.app/articles";

export const updateArticle = async (article: Article) => {
    const token = localStorage.getItem("token"); // login sonrası sakladığın JWT

    if (!token) throw new Error("Token bulunamadı, giriş yapmanız gerekiyor");

    try {
        const { relatedArticlesData, ...payload } = article;
        console.log(payload);
        const url = `${API_BASE_URL}/${article.id}`;  // sadece update

        const response = await axios.put(url, payload, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`, // token ekleniyor
            },
        });

        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            console.error("Makale kaydedilirken bir Axios hatası oluştxu:", error.message);
            if (error.response) {
                console.error("Sunucu yanıtı:", error.response.data);
                console.error("Sunucu durumu:", error.response.status);
            } else if (error.request) {
                console.error("Yanıt alınamadı:", error.request);
            }
        } else {
            console.error("Makale kaydedilirken bilinmeyen bir hata oluştu:", error);
        }
        throw error;
    }
};